import { render, staticRenderFns } from "./AreaSearch.vue?vue&type=template&id=e4b35978&scoped=true&"
import script from "./AreaSearch.vue?vue&type=script&lang=ts&"
export * from "./AreaSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AreaSearch.vue?vue&type=style&index=0&id=e4b35978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b35978",
  null
  
)

export default component.exports